import { OrgTypes } from '@mode/shared/contract-common';
import * as angular from 'angular';

import { ClientDataService } from '~/services/client-data-service';

class EditorSettingsDropdownMenuController {
  static $inject = ['ClientDataService'];

  //bindings
  onThemeToggled: any;
  onVerticalModeToggled: any;
  preferences: any;
  vertical: boolean;
  displayTableDisabled: boolean;
  owner: OrgTypes.Organization;

  constructor(private clientDataService: ClientDataService) {}

  defaultLimitEnabled(): boolean {
    return (
      this.preferences &&
      this.preferences.sql_editor_preferences &&
      this.preferences.sql_editor_preferences.default_limit_enabled
    );
  }

  createDisplayTablesEnabled() {
    return this.preferences && this.preferences.display_table_enabled;
  }

  toggleLimitQueriesPreference() {
    this.clientDataService.updateAccountPreference({
      sql_editor_preferences: {
        default_limit_enabled: !this.defaultLimitEnabled(),
      },
    });
  }

  toggleCreateDisplayTablePreference() {
    this.clientDataService.updateAccountPreference({
      display_table_enabled: !this.createDisplayTablesEnabled(),
    });
  }
}

const EditorSettingsDropdownMenuComponent: angular.IComponentOptions = {
  controller: EditorSettingsDropdownMenuController,
  controllerAs: 'ctrl',
  require: { tiledPanes: '?^^' },
  bindings: {
    onThemeToggled: '&',
    onVerticalModeToggled: '&',
    preferences: '<',
    vertical: '<',
    displayTableDisabled: '<',
    owner: '<',
    showSqlSettings: '<',
    showFlamingoToggle: '<',
  },
  template: `
    <span uib-dropdown is-open="dropOpen">
      <a
        href="#"
        class="editor-settings-trigger"
        id="editor-settings-dropdown-trigger"
        title="Toggle editor settings"
        role="button"
        ng-class="{active: dropOpen, light: ctrl.preferences.editor_theme === 'light'}"
        ng-click="ctrl.tiledPanes"
        uib-dropdown-toggle>
        <capra-icon class="capra-settings-trigger"
        icon="icon-gear"></capra-icon>
      </a>
      <ul uib-dropdown-menu class="dropdown-menu pull-right" aria-labelledby="editor-settings-dropdown-trigger">
        <li class="context-item" ng-class="{selected: ctrl.preferences.editor_theme === 'light'}">
          <a class="context-link" ng-click="ctrl.onThemeToggled()" role="button">
            <span class="indicator"></span>
            Light mode
          </a>
        </li>
        <li class="context-item" ng-class="{selected: ctrl.preferences.editor_theme === 'dark'}">
          <a class="context-link" ng-click="ctrl.onThemeToggled()" role="button">
            <span class="indicator"></span>
            Dark mode
          </a>
        </li>

        <li ng-if="ctrl.showSqlSettings" class="divider context-divider"></li>

        <li ng-if="ctrl.showSqlSettings" class="context-item" ng-class="{selected: !(ctrl.vertical)}">
          <a class="context-link" ng-click="ctrl.onVerticalModeToggled()" role="button">
            <span class="indicator"></span>
            Side by side panels
            <i class="icon-panels-side-to-side"></i>
          </a>
        </li>
        <li ng-if="ctrl.showSqlSettings" class="context-item" ng-class="{selected: ctrl.vertical}">
          <a class="context-link" ng-click="ctrl.onVerticalModeToggled()" role="button">
            <span class="indicator"></span>
            Stacked panels
            <i class="icon-panels-stacked"></i>
          </a>
        </li>

        <li class="divider context-divider" ng-if="ctrl.showSqlSettings"></li>
        <li class="context-item" ng-class="{selected: ctrl.defaultLimitEnabled()}" ng-if="ctrl.showSqlSettings">
          <a class="context-link" ng-click="ctrl.toggleLimitQueriesPreference()" role="button">
            <i class="context-checkmark icon-check-mark-selected"></i>
            Apply 100 row limit to new queries
          </a>
        </li>
        <li class="divider context-divider" ng-if="!ctrl.displayTableDisabled && !ctrl.owner.user && ctrl.showSqlSettings"></li>
        <li class="context-item" ng-if="!ctrl.displayTableDisabled && !ctrl.owner.user && ctrl.showSqlSettings" ng-class="{selected: ctrl.createDisplayTablesEnabled()}">
          <a class="context-link" ng-click="ctrl.toggleCreateDisplayTablePreference()" role="button">
            <i class="context-checkmark icon-check-mark-selected"></i>
            Generate a Display Table when new queries return
          </a>
        </li>

        <li class="divider context-divider" ng-if="ctrl.showSqlSettings"></li>
        <li class="context-item" ng-if="ctrl.showSqlSettings">
          <a
            class="context-link"
            preferences="ctrl.preferences"
            sql-settings-modal
            role="button"
            ng-if="ctrl.showSqlSettings"
            data-test="autocomplete-settings">
            Autocomplete settings...
          </a>
        </li>

      </ul>
    </span>
`,
};

angular.module('mode.components').component('editorSettingsDropdownMenu', EditorSettingsDropdownMenuComponent);
